module.exports = __webpack_public_path__ + "img/ic_save.4b30d2ba.svg";